import React from "react";
import Image from "gatsby-image";
import { ArticlePhotos } from "./ArticlePhotos";

export const ArticleData = () => {
  const images = ArticlePhotos();
  return {
    date: "10.01.2020r",
    category: "lojalność klientów, marketing, klient",
    title: "Dlaczego warto zainwestować w lojalność klientów?",
    description: (
      <>
        Czy wiesz, jak ważny jest Twój obecny klient? Nierzadko, w pogoni za
        nowymi nabywcami naszych usług i towarów, zapominamy o tych, którzy już
        nimi są. Tymczasem to oni stanowią siłę napędową przedsiębiorstwa i od
        nich w dużej mierze zależy jego sukces. <b>Lojalność klientów</b>,
        inaczej<b> lojalność konsumencka</b> - dlaczego jest tak ważna i jak ją
        wykorzystać?
      </>
    ),
    seo: "Czy wiesz, jak ważny jest Twój obecny klient?",
    slug: "/blog/dlaczego_warto_zainwestowac_w_lojalnosc_klientow",
    hero: (
      <Image
        alt=""
        objectPosition={"center"}
        objectFit={"contain"}
        fluid={images.hero.childImageSharp.fluid}
      />
    ),
    text: {
      first: {
        title: "Lojalność to najwyższy stopień zaangażowania",
        text: (
          <>
            <b>Lojalny klient</b> jest wierny tylko jednej marce. Często kupuje
            jej produkty i rekomenduje ją innym. Nie jest to jednak jedyny
            wyznacznik, bo taki nabywca może w każdej chwili dokonać innego
            wyboru, np. skusić się na niższą cenę u konkurencji. Nie czuje się
            on zobowiązany do kolejnego zakupu czy skorzystania z usługi - to
            lojalność pozorna. Ta prawdziwa niesie ze sobą bowiem{" "}
            <b>przywiązanie</b> - a więc emocjonalną więź, zaangażowanie. Taki
            klient jest w stanie nawet zaakceptować podwyżkę cen, a jednocześnie
            każdy dodatkowy bonus czy inne wartości mu oferowane przez markę są
            odbierane przez niego bardziej pozytywnie i lepiej zapamiętywane.
          </>
        ),
      },
      second: {
        title: "",
        text: (
          <>
            Aby zdobyć lojalność klientów, ważne jest zachowanie
            <b> przedsiębiorstwa na każdym etapie procesu zakupowego</b>, a
            nawet po nim. Istotne, aby nabywca był zadowolony z wyboru naszej
            firmy - ale należy o niego zadbać także po transakcji. Dzięki temu
            mamy szansę, że jeszcze do nas wróci, a z czasem stanie się lojalny.
          </>
        ),
      },
      third: {
        title: "Stały klient - tańszy klient",
        text: (
          <>
            Zatrzymanie przy sobie swojego obecnego klienta jest nawet{" "}
            <b>5 do 7 razy tańsze</b> niż zdobycie nowego. Ta oszczędność wynika
            z tego, że - przede wszystkim - możemy zmniejszyć nakłady na
            reklamę. Znacznie łatwiej do zakupu przekonać jest{" "}
            <b>zadowolonego klienta </b>
            (prawdopodobieństwo wynosi aż 60-70%), niż przyciągnąć nowego -
            takiego, który nie miał jeszcze styczności z naszą firmą
            (prawdopodobieństwo zakupu to zaledwie 5-20%). Na mniejszą potrzebę
            inwestycji w tradycyjne formy reklamy przekłada się również fakt, że
            lojalny klient z pewnością będzie polecał innym osobom naszą firmę.
            Taka forma promocji jest też zdecydowanie skuteczniejsza: nowy
            nabywca jest bardziej skłonny posłuchać{" "}
            <b>rekomendacji znajomego</b> niż wybrać markę "w ciemno".
          </>
        ),
      },
      fourth: {
        title: "Wysoki standard obsługi, kontaktowość i program lojalnościowy",
        text: (
          <>
            Można wyróżnić 3 najważniejsze wskazówki co do tego, w jaki sposób
            zbudować lojalność klientów. Pierwszą i najważniejszą pozostaje
            <b> wysoki standard obsługi</b>. Pierwsze wrażenie jest
            najważniejsze - to właśnie pierwszy kontakt nabywcy z firmą decyduje
            o jego opinii. Zadbaj więc o to, by każda transakcja przebiegała w
            odpowiedni sposób - od powitania po podpis na umowie czy wydanie
            paragonu/faktury. Statystyki pokazują, że 67% klientów przestaje
            kupować produkty czy korzystać z usług, jeśli doświadczyło złej
            obsługi. Dlatego nie lekceważ żadnego zakupu i zawsze staraj się być
            pomocny, nawet w momencie pojawienia się problemów.
          </>
        ),
      },
      fifth: {
        title: "",
        text: (
          <>
            Po drugie, bądź <b>w kontakcie</b> ze swoimi klientami - w sposób,
            jaki oni preferują. Informuj ich o nowościach i sprawiaj wrażenie,
            że jesteś cały czas dostępny, m.in. szybko znajdując rozwiązania dla
            ich problemów. Mogą to być media społecznościowe, e-mail marketing
            czy nawet infolinia. Ważne, żebyś poznał swoich klientów i
            umożliwiał im do siebie <b>łatwy dla nich dostęp</b>.
          </>
        ),
      },
      sixth: {
        title: "",
        text: (
          <>
            Po trzecie, to, co się samo nasuwa, gdy na myśl przyjdzie nam hasło
            "lojalność konsumencka" - czyli <b>program lojalnościowy</b>. Jego
            zasady muszą być <b>proste i zrozumiałe</b> dla klientów, a
            jednocześnie dobrze by było, gdyby był on w jakiś sposób
            <b> unikalny</b>. Może to być zbieranie punktów albo bonusy dostępne
            tylko dla członków programu. Dzięki temu klienci zyskają większą
            motywację do tego, by częściej i więcej korzystać z Twoich usług.
          </>
        ),
      },
      seventh: {
        title: "",
        text: (
          <>
            Zdobycie lojalności klientów nie jest łatwym zadaniem, ale
            zdecydowanie opłacalnym. Nie lekceważ tych, którzy już coś od Ciebie
            kupili. Poznaj ich motywacje i doświadczenia, a będziesz wiedział, w
            jaki sposób sprawić, by stali się prawdziwie lojalni.
          </>
        ),
      },
    },
  };
};
